if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.targetDate = new Date(this.getAttribute('data-target-date'));
        this.daysEl = this.querySelector('[data-countdown-days]');
        this.hoursEl = this.querySelector('[data-countdown-hours]');
        this.minutesEl = this.querySelector('[data-countdown-minutes]');
        this.secondsEl = this.querySelector('[data-countdown-seconds]');

        this.update();
        this.interval = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      update() {
        const diff = Math.max(0, this.targetDate - new Date());
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        if (this.daysEl) this.daysEl.textContent = days;
        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

        if (diff <= 0) clearInterval(this.interval);
      }
    }
  );
}
